const PDP_COMPAT_HANDLE_ALIASES = {
  'tentbox-lite': new Set(['tentbox-lite', 'tentbox-lite-2-0']),
  'tentbox-lite-2-0': new Set(['tentbox-lite', 'tentbox-lite-2-0']),
}

function productHandlesForVehicleCompatBanner (handle) {
  const aliases = PDP_COMPAT_HANDLE_ALIASES[handle]
  return aliases ? [...aliases] : [handle]
}

class VehicleCheckerBanner extends HTMLElement {
  connectedCallback () {
    this.textElement = this.querySelector('.vehicle-checker-banner__text')
    this.iconCompatible = this.querySelector('.vehicle-checker-banner__icon--compatible')
    this.iconIncompatible = this.querySelector('.vehicle-checker-banner__icon--incompatible')
    this.contentEl = this.querySelector('.vehicle-checker-banner__content')
    this.linkEl = this.querySelector('.vehicle-checker-banner__link')
    this.productHandle = (this.getAttribute('data-product-handle') || '').trim()
    this.compatibleText = this.getAttribute('data-compatible-text') || ''
    this.incompatibleText = this.getAttribute('data-incompatible-text') || ''
    if (!this.localStorageValue || !this.textElement || this.textElement.textContent === '') {
      this.remove()
      return
    }

    const compatibility = this.vehicleCompatibility
    if (!compatibility || !this.productHandle) {
      this.remove()
      return
    }

    const handles = productHandlesForVehicleCompatBanner(this.productHandle)
    const isCompatible = Array.isArray(compatibility.compatibleProducts) &&
      handles.some(h => compatibility.compatibleProducts.includes(h))
    this.classList.remove('sr-only')
    this.updateBannerText(isCompatible)
    this.updateBannerState(isCompatible)
  }

  get localStorageValue () {
    return localStorage.getItem('vehicleCheckerBannerData')
  }

  get vehicleCompatibility () {
    try {
      const raw = localStorage.getItem('vehicleCompatibility')
      if (!raw) return null
      return JSON.parse(raw)
    } catch (e) {
      return null
    }
  }

  updateBannerText (isCompatible) {
    try {
      const bannerData = JSON.parse(this.localStorageValue)
      if (!bannerData?.make || !bannerData?.model) {
        this.remove()
        return
      }

      let vehicleText = `${bannerData.make} ${bannerData.model}`
      if (vehicleText.length > 30) {
        vehicleText = `${vehicleText.slice(0, 20)}…`
      }
      const baseText = isCompatible ? (this.compatibleText || this.textElement.textContent) : (this.incompatibleText || this.textElement.textContent)
      const updatedText = baseText.replace(/\[vehicle\]/g, `<strong>${vehicleText}</strong>`)

      this.textElement.innerHTML = updatedText
    } catch (error) {
      console.error('Error updating vehicle checker banner text:', error)
      this.remove()
    }
  }

  updateBannerState (isCompatible) {
    if (isCompatible) {
      this.classList.remove('bg-iron/15')
      this.classList.add('bg-success/15')
      if (this.contentEl) {
        this.contentEl.classList.remove('text-iron')
        this.contentEl.classList.add('text-success')
      }
      if (this.linkEl) {
        this.linkEl.classList.remove('text-iron')
        this.linkEl.classList.add('text-black')
      }
      if (this.iconCompatible) this.iconCompatible.classList.remove('hidden')
      if (this.iconIncompatible) this.iconIncompatible.classList.add('hidden')
    } else {
      this.classList.remove('bg-success/15')
      this.classList.add('bg-iron/15')
      if (this.contentEl) {
        this.contentEl.classList.remove('text-success')
        this.contentEl.classList.add('text-iron')
      }
      if (this.linkEl) {
        this.linkEl.classList.remove('text-black')
        this.linkEl.classList.add('text-iron')
      }
      if (this.iconCompatible) this.iconCompatible.classList.add('hidden')
      if (this.iconIncompatible) this.iconIncompatible.classList.remove('hidden')
    }
  }
}

if (!customElements.get('vehicle-checker-banner')) {
  customElements.define('vehicle-checker-banner', VehicleCheckerBanner)
}
